window.animalfriends = window.animalfriends || {};

window.animalfriends.scroller = (function ($) {
    "use strict";
    var module = {};
    var speed = 600;

    module.scrollToElem = function ($elem, offset) {
        if (!$elem) { return false; }
        
        var elemPos = $elem.offset().top;

        if ($elem.is(":hidden")) return false;

        module.scrollToPosition(elemPos, null, offset);
    };

    module.scrollToPosition = function (pos, hash, offset) {
        if (typeof offset === "undefined") { offset = 0; }

        $('html, body').animate({
            scrollTop: (pos + offset)
        }, speed, function () {
            // This causes an issue with the scrolling due to the sticky banner not being accommodated for when we set the hash.
            // if (typeof hash !== undefined && hash !== null) {
            //     window.location.hash = hash;
            // }
        });
    };

    module.goToElement = function ($elem, offset) {
        if (!$elem) { return false; }
        if (typeof offset === "undefined") { offset = 0; }

        var elemPos = $elem.offset().top;

        if ($elem.is(":hidden")) return false;

        $('html, body').scrollTop((elemPos + offset + 1))
    };

    function identfyScrollPosition(event, urlHash){

        var $a = event ? $(event.target) : null,
        href = $a ? $a.attr('href') : null,
        hash,
        $target,
        offset = 0;

        var offsetHeader = $(".header").height();

        if (href || urlHash) {
            hash = href ? href.substring(href.indexOf('#')) : urlHash
            $target = hash == "#" ? null : $(hash)
        }
        
        if(event) event.preventDefault();

        setTimeout(function() {

        if ($target && $target.length) {
            if(event) event.preventDefault();
            offset += $target.offset().top-offsetHeader;

            
            offset -= 10; // Slight amount of padding to add breathing space

            module.scrollToPosition(offset, hash);
        }
        },500)
    }

    module.init = function () {
        var $scroll = $('html, body'),
        $body = $scroll.filter('body');

        $body.on('click', 'a[href*="#"]', function (event) {
        var href = $(this).attr('href');
        // Only intercept if href is a hash link for the current page
        if (href && (href.charAt(0) === '#' || href.indexOf(window.location.pathname + '#') === 0)) {
            identfyScrollPosition(event);
        }
        // Otherwise, let the browser handle navigation to other pages
    });
    };

    $(document).ready(function () {
        module.init();

        var hash = window.location.hash;
        if(hash) identfyScrollPosition(event, hash);
    });

    return module;
})(jQuery);
